import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';

function ViewActivityTable({
  tableData,
  date,
  handleSelectDate,
  workspaceMember,
}) {
  return (
    <table className="table activity-table" style={{ marginTop: 24 }}>
      <thead>
        <tr className="table-row">
          <th scope="col" className="table-cell">
            <div className="avatar-user">
              {workspaceMember?.user?.firstName?.slice(0, 1)}
              {workspaceMember?.user?.lastName?.slice(0, 1)}
            </div>
            <div className="name-user">
              {`${workspaceMember?.user?.firstName} ${workspaceMember?.user?.lastName}`}
            </div>
          </th>
          {tableData.dates?.map((day, index) => (
            <th
              key={index}
              scope="col"
              style={{ cursor: 'pointer' }}
              className={moment(date).day() === index ? 'selected-date table-cell' : 'table-cell'}
              onClick={() => handleSelectDate(new Date(day), 'Screenshots')}
            >
              <div className="dayname-date">{moment(day).date()}</div>
              <div className="subdate-container">
                <div className="day-date">{moment(day).format('ddd')}</div>
                <div className="month-date">{moment(day).format('MMM')}</div>
              </div>
            </th>
          ))}
          <th scope="col" className="table-cell">
            Total
          </th>
        </tr>
      </thead>
      <tbody>
        <tr className="table-row">
          <th scope="row" className="table-cell table-header">Time</th>
          {tableData.times.map((time, index) => (
            <td
              key={index}
              role="gridcell"
              style={{ cursor: 'pointer' }}
              className={
                  `table-cell table-value ${moment(date).day() === index && 'selected-date'}`
                }
              onClick={() => handleSelectDate(new Date(tableData.dates[index]), 'Screenshots')}
            >
              <span className="table-value">{time}</span>
            </td>
          ))}
          <td className="table-cell table-value">
            {tableData.totalTime}
          </td>
        </tr>
        <tr className="table-row">
          <th scope="row" className="table-cell table-header">Avg Activity</th>
          {tableData.avgActivities.map((avgActivity, index) => (
            <td
              key={index}
              role="gridcell"
              style={{ cursor: 'pointer' }}
              className={
                  `table-cell table-value ${moment(date).day() === index && 'selected-date'}`
                }
              onClick={() => handleSelectDate(new Date(tableData.dates[index]), 'Screenshots')}
            >
              {avgActivity
                ? (
                  <span className={`
                      ${avgActivity <= 25 && 'low-activity'}
                      ${avgActivity >= 75 && ' high-activity'}`}
                  >
                    {`${avgActivity}%`}
                  </span>
                )
                : '--%'}
            </td>
          ))}
          <td className="table-cell table-value">
            {tableData.totalAvgActivity
              ? (
                <span className={`
                    ${tableData.totalAvgActivity <= 25 && 'low-activity'}
                    ${tableData.totalAvgActivity >= 75 && ' high-activity'}`}
                >
                  {`${tableData.totalAvgActivity}%`}
                </span>
              )
              : '--%'}
          </td>
        </tr>
      </tbody>
    </table>
  );
}

ViewActivityTable.propTypes = {
  tableData: PropTypes.shape({
    dates: PropTypes.arrayOf(PropTypes.string),
    times: PropTypes.arrayOf(PropTypes.string),
    avgActivities: PropTypes.arrayOf(PropTypes.number),
    totalTime: PropTypes.string,
    totalAvgActivity: PropTypes.number,
  }).isRequired,
  date: PropTypes.instanceOf(Date),
  handleSelectDate: PropTypes.func.isRequired,
  workspaceMember: PropTypes.shape({
    id: PropTypes.number.isRequired,
    user: PropTypes.shape({
      id: PropTypes.number.isRequired,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
      email: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

export default ViewActivityTable;
